export default "__VITE_ASSET__4bd70f00__"